/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  HeroTokensVaultMock,
  HeroTokensVaultMockInterface,
} from "../HeroTokensVaultMock";

const _abi = [
  {
    inputs: [],
    name: "NotEnoughAllowance",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    name: "process",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "processLastCall",
    outputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class HeroTokensVaultMock__factory {
  static readonly abi = _abi;
  static createInterface(): HeroTokensVaultMockInterface {
    return new Interface(_abi) as HeroTokensVaultMockInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): HeroTokensVaultMock {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as HeroTokensVaultMock;
  }
}
